module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei8.svg";